import React, { useContext, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { ICreateAndUpdateFinancialGroup } from "../../../../../../types/financialGroup";
import utils from "../../../../../../utils";
import { financialGroup } from "../../../../../../validators";
import api from "../../../../../../api";
import { CustomButton2, CustomInput } from "../../../../../../components";
import Context from "../../../../../../context";
import "./index.scss";
import Column from "../../../../../../components/CustomView/Column";
import { useTranslation } from "react-i18next";

type props = {
  onCancel: () => void;
  data: any;
};

const UpdateFinancialGroup = ({ data, onCancel }: props) => {
  // ========================================== Value Validations =======================================================

  const { setSelectedFinancialGroup, selectedFinancialGroup, updateFunction } =
    useContext(Context.FinancialGroupScreen);

  const [errors, setErrors] = useState({
    name: "",
    total: "",
    cycle: "",
    agentSubscription: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [financialGroupData, setFinancialGroupData] =
    useState<ICreateAndUpdateFinancialGroup>({
      name: selectedFinancialGroup?.name,
      subscriptionAgent: {
        cycle: selectedFinancialGroup?.subscriptionAgent?.cycle,
        share: {
          admin: selectedFinancialGroup?.subscriptionAgent?.share?.admin,
          company: selectedFinancialGroup?.subscriptionAgent?.share?.company,
          superAgent:
            selectedFinancialGroup?.subscriptionAgent?.share?.superAgent,
          driver: selectedFinancialGroup?.subscriptionAgent?.share?.driver,
          tax: selectedFinancialGroup?.subscriptionAgent?.share?.tax,
        },
      },
      subscriptionStudent: {
        cycle: selectedFinancialGroup?.subscriptionStudent?.cycle,
        share: {
          admin: selectedFinancialGroup?.subscriptionStudent?.share?.admin,
          company: selectedFinancialGroup?.subscriptionStudent?.share?.company,
          superAgent:
            selectedFinancialGroup?.subscriptionStudent?.share?.superAgent,
          driver: selectedFinancialGroup?.subscriptionStudent?.share?.driver,
          tax: selectedFinancialGroup?.subscriptionStudent?.share?.tax,
        },
      },
    });

  useEffect(() => {
    setFinancialGroupData({
      name: selectedFinancialGroup?.name,
      agentSubscription: selectedFinancialGroup?.agentSubscription,
      subscriptionAgent: {
        cycle: selectedFinancialGroup?.subscriptionAgent?.cycle,
        share: {
          admin: selectedFinancialGroup?.subscriptionAgent?.share?.admin,
          company: selectedFinancialGroup?.subscriptionAgent?.share?.company,
          superAgent:
            selectedFinancialGroup?.subscriptionAgent?.share?.superAgent,
          driver: selectedFinancialGroup?.subscriptionAgent?.share?.driver,
          municipality:
            selectedFinancialGroup?.subscriptionAgent?.share?.municipality,
          tax: selectedFinancialGroup?.subscriptionAgent?.share?.tax,
        },
      },
      subscriptionStudent: {
        cycle: selectedFinancialGroup?.subscriptionStudent?.cycle,
        share: {
          admin: selectedFinancialGroup?.subscriptionStudent?.share?.admin,
          company: selectedFinancialGroup?.subscriptionStudent?.share?.company,
          superAgent:
            selectedFinancialGroup?.subscriptionStudent?.share?.superAgent,
          driver: selectedFinancialGroup?.subscriptionStudent?.share?.driver,
          municipality:
            selectedFinancialGroup?.subscriptionStudent?.share?.municipality,
          tax: selectedFinancialGroup?.subscriptionStudent?.share?.tax,
        },
      },
    });
  }, [selectedFinancialGroup]);

  // ========================================== Local Functions =========================================================

  const onFormValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFinancialGroupData({
      ...financialGroupData,
      [event.target.name]: utils.convertNumbers2English(event.target.value),
    });
  };

  const onCloseModal = () => {
    setFinancialGroupData({
      name: "",
      subscriptionAgent: {
        cycle: 0,
        share: {
          admin: "",
          company: "",
          superAgent: "",
          driver: "",
          tax: "",
        },
      },
      subscriptionStudent: {
        cycle: 0,
        share: {
          admin: "",
          company: "",
          superAgent: "",
          driver: "",
          tax: "",
        },
      },
    });
    onCancel();
  };

  const { t } = useTranslation();

  // ============================================== API Call ============================================================

  const updateHandler = () => {
    let errorsText = {
      name: "",
      total: "",
      cycle: "",
      agentSubscription: "",
    };
    let total = {};

    total =
      Number(financialGroupData.subscriptionStudent?.share?.admin) +
      Number(financialGroupData.subscriptionStudent?.share?.superAgent) +
      Number(financialGroupData.subscriptionStudent?.share?.company) +
      Number(financialGroupData.subscriptionStudent?.share?.driver) +
      Number(financialGroupData.subscriptionStudent?.share?.tax) +
      Number(financialGroupData.subscriptionStudent?.share?.municipality);

    if (!financialGroupData.name)
      errorsText = {
        ...errorsText,
        name: t("financial_group_name_is_required"),
      };
    if (
      !financialGroupData?.subscriptionAgent?.cycle &&
      !financialGroupData?.subscriptionStudent?.cycle
    )
      errorsText = {
        ...errorsText,
        cycle: t("cycle_is_required"),
      };
    if (total !== 100)
      errorsText = {
        ...errorsText,
        total: t("total_pescent_should_be_100"),
      };
    // if (financialGroupData?.agentSubscription)
    //   errorsText = {
    //     ...errorsText,
    //     agentSubscription: "مقدار شهریه شرکت حمل و نقل را تعیین کنید",
    //   };

    setErrors(errorsText);

    if (
      financialGroupData.name &&
      financialGroupData.subscriptionAgent?.cycle &&
      total === 100
    )
      updateFunction(financialGroupData, selectedFinancialGroup._id);
  };

  // ============================================ JSX Container =========================================================
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div className="cm-body">
        <section className="create-role">
          <div id="create_financial_group_container">
            <Container>
              <Row>
                {/* Group Name */}
                <Column
                  medium={6}
                  className="form-input-holder dropdown form-column"
                >
                  <CustomInput
                    placeHolder={t("financialGroupName")}
                    name="name"
                    value={
                      financialGroupData?.name
                        ? financialGroupData?.name
                        : data?.name
                    }
                    onValueChange={(
                      event: React.ChangeEvent<HTMLInputElement>
                    ) => {
                      setFinancialGroupData((prev) => ({
                        ...prev,
                        name: event.target.value,
                      }));
                      //utils.onValueChangeLetter({ event, length: 25 }) && onFormValueChange(event);
                    }}
                    label={t("financialGroupName")}
                  />
                  <div className="error">
                    {errors.name !== "" && errors.name}
                  </div>
                </Column>
                <Column
                  medium={4}
                  className="form-input-holder dropdown form-column"
                >
                  <CustomInput
                    placeHolder={t("companyFee")}
                    name="agentSubscription"
                    value={
                      financialGroupData?.agentSubscription
                        ? financialGroupData?.agentSubscription
                        : data?.agentSubscription
                        ? data?.agentSubscription
                        : "0"
                    }
                    onValueChange={(
                      event: React.ChangeEvent<HTMLInputElement>
                    ) => {
                      setFinancialGroupData((prev: any) => {
                        return {
                          ...prev,
                          agentSubscription: event.target.value,
                        };
                      });
                      setErrors((prev) => ({ ...prev, agentSubscription: "" }));
                    }}
                    label={t("companyFee")}
                  />
                  <div className="error">
                    {errors.agentSubscription !== "" &&
                      errors.agentSubscription}
                  </div>
                </Column>
              </Row>
              <Row className="form-title">
                <hr />
                <div className="title-text">
                  <span>{t("subscriptionShare")}</span>
                  <span className="total-error">
                    {" "}
                    {errors.total !== "" && "(" + errors.total + ")"}
                  </span>
                </div>{" "}
              </Row>
              <Row>
                {/* Admin Share */}
                <Column medium={6} className="form-input-holder">
                  <CustomInput
                    placeHolder={t("admin")}
                    name="travelShareAdmin"
                    value={
                      financialGroupData?.subscriptionStudent?.share?.admin
                    }
                    onValueChange={(
                      event: React.ChangeEvent<HTMLInputElement>
                    ) => {
                      setFinancialGroupData((prev) => {
                        let state = {
                          ...prev,
                          subscriptionStudent: {
                            ...prev.subscriptionStudent,
                            share: {
                              ...prev.subscriptionStudent?.share,
                              admin: event.target.value,
                            },
                          },
                          subscriptionAgent: {
                            ...prev.subscriptionAgent,
                            share: {
                              ...prev.subscriptionAgent?.share,
                              admin: event.target.value,
                            },
                          },
                        };

                        return state;
                      });
                      // utils.onValueChangeNumber({ event, length: 5 }) && onFormValueChange(event);
                    }}
                    label={t("admin")}
                  />
                </Column>
                {/* Group Name */}
                <Column medium={6} className="form-input-holder">
                  <CustomInput
                    placeHolder={t("superAgent")}
                    name="travelShareSuperAgent"
                    value={
                      financialGroupData?.subscriptionStudent?.share?.superAgent
                    }
                    onValueChange={(
                      event: React.ChangeEvent<HTMLInputElement>
                    ) => {
                      setFinancialGroupData((prev) => {
                        let state = {
                          ...prev,
                          subscriptionStudent: {
                            ...prev.subscriptionStudent,
                            share: {
                              ...prev.subscriptionStudent?.share,
                              superAgent: event.target.value,
                            },
                          },
                          subscriptionAgent: {
                            ...prev.subscriptionAgent,
                            share: {
                              ...prev.subscriptionAgent?.share,
                              superAgent: event.target.value,
                            },
                          },
                        };
                        return state;
                      });

                      //utils.onValueChangeNumber({ event, length: 5 }) && onFormValueChange(event);
                    }}
                    label={t("superAgent")}
                  />
                </Column>
                <Column medium={6} className="form-input-holder">
                  <CustomInput
                    placeHolder={t("municipality")}
                    name="travelShareSuperAgent"
                    value={
                      financialGroupData?.subscriptionStudent?.share
                        ?.municipality
                    }
                    onValueChange={(
                      event: React.ChangeEvent<HTMLInputElement>
                    ) => {
                      setFinancialGroupData((prev) => {
                        let state = {
                          ...prev,
                          subscriptionStudent: {
                            ...prev.subscriptionStudent,
                            share: {
                              ...prev.subscriptionStudent?.share,
                              municipality: event.target.value,
                            },
                          },
                          subscriptionAgent: {
                            ...prev.subscriptionAgent,
                            share: {
                              ...prev.subscriptionAgent?.share,
                              superAgent: event.target.value,
                            },
                          },
                        };

                        return state;
                      });

                      //utils.onValueChangeNumber({ event, length: 5 }) && onFormValueChange(event);
                    }}
                    label={t("municipality")}
                  />
                </Column>
                {/* Group Name */}
                <Column medium={6} className="form-input-holder">
                  <CustomInput
                    placeHolder={t("company")}
                    name="travelShareAgent"
                    value={
                      financialGroupData?.subscriptionStudent?.share?.company
                    }
                    onValueChange={(
                      event: React.ChangeEvent<HTMLInputElement>
                    ) => {
                      setFinancialGroupData((prev) => {
                        let state = {
                          ...prev,
                          subscriptionStudent: {
                            ...prev.subscriptionStudent,
                            share: {
                              ...prev.subscriptionStudent?.share,
                              company: event.target.value,
                            },
                          },
                          subscriptionAgent: {
                            ...prev.subscriptionAgent,
                            share: {
                              ...prev.subscriptionAgent?.share,
                              company: event.target.value,
                            },
                          },
                        };
                        return state;
                      });
                      //utils.onValueChangeNumber({ event, length: 5 }) && onFormValueChange(event);
                    }}
                    label={t("company")}
                  />
                </Column>
                {/* Group Name */}
                <Column medium={6} className="form-input-holder">
                  <CustomInput
                    placeHolder={t("driver")}
                    name="travelShareDriver"
                    value={
                      financialGroupData?.subscriptionStudent?.share?.driver
                    }
                    onValueChange={(
                      event: React.ChangeEvent<HTMLInputElement>
                    ) => {
                      setFinancialGroupData((prev) => {
                        let state = {
                          ...prev,
                          subscriptionStudent: {
                            ...prev.subscriptionStudent,
                            share: {
                              ...prev.subscriptionStudent?.share,
                              driver: event.target.value,
                            },
                          },
                          subscriptionAgent: {
                            ...prev.subscriptionAgent,
                            share: {
                              ...prev.subscriptionAgent?.share,
                              driver: event.target.value,
                            },
                          },
                        };

                        return state;
                      });
                      //utils.onValueChangeNumber({ event, length: 5 }) && onFormValueChange(event);
                    }}
                    label={t("driver")}
                  />
                </Column>
                {/* Group Name */}
                <Col lg={6} className="form-input-holder">
                  <CustomInput
                    placeHolder={t("tax")}
                    name="travelShareTax"
                    value={financialGroupData?.subscriptionStudent?.share?.tax}
                    onValueChange={(
                      event: React.ChangeEvent<HTMLInputElement>
                    ) => {
                      setFinancialGroupData((prev) => {
                        let state = {
                          ...prev,
                          subscriptionStudent: {
                            ...prev.subscriptionStudent,
                            share: {
                              ...prev.subscriptionStudent?.share,
                              tax: event.target.value,
                            },
                          },
                          subscriptionAgent: {
                            ...prev.subscriptionAgent,
                            share: {
                              ...prev.subscriptionAgent?.share,
                              tax: event.target.value,
                            },
                          },
                        };

                        return state;
                      });
                      //utils.onValueChangeNumber({ event, length: 5 }) && onFormValueChange(event);
                    }}
                    label={t("tax")}
                  />
                </Col>
                <Column medium={6} className="form-input-holder">
                  <CustomInput
                    placeHolder={t("cycle")}
                    name="cycle"
                    value={financialGroupData?.subscriptionAgent?.cycle?.toString()}
                    onValueChange={(
                      event: React.ChangeEvent<HTMLInputElement>
                    ) => {
                      setFinancialGroupData((prev) => {
                        let state = {
                          ...prev,
                          subscriptionStudent: {
                            ...prev.subscriptionStudent,
                            cycle: Number(event.target.value),
                          },
                          subscriptionAgent: {
                            ...prev.subscriptionAgent,
                            cycle: Number(event.target.value),
                          },
                        };

                        return state;
                      });
                      //utils.onValueChangeNumber({ event, length: 5 }) && onFormValueChange(event);
                    }}
                    label={t("cycle")}
                  />
                  <div className="error">
                    {errors.cycle !== "" && errors.cycle}
                  </div>
                </Column>
              </Row>
            </Container>
            <Container>
              <Row className="nav-buttons">
                <Column medium={3}>
                  <CustomButton2
                    isLoading={isLoading}
                    onClick={onCloseModal}
                    type="danger"
                    title={t("cancel")}
                  />
                </Column>
                <Column medium={3}>
                  <CustomButton2
                    isLoading={isLoading}
                    onClick={updateHandler}
                    type="primary"
                    title={t("approve")}
                  />
                </Column>
              </Row>
            </Container>
          </div>
        </section>
      </div>
    </div>
  );
};

export default UpdateFinancialGroup;
